import { fetchContacts } from "../../services/contacts";
import { action, thunk, computed } from "easy-peasy";

export const contactsModel = {
  contacts: [],
  phoneNumber: computed(
    (state) => state.contacts.filter((el) => el.title == "ТЕЛЕФОН")[0]
  ),
  error: null,
  setError: action((state, payload) => {
    state.error = payload;
  }),
  setContacts: action((state, payload) => {
    state.contacts = payload;
  }),
  getContacts: thunk(async (actions, payload) => {
    try {
      const request = await fetchContacts();
      if (request && !request.error) actions.setContacts(request);
    } catch (err) {
      actions.setError(err);
    }
  }),
};
